import { SYSTEM_SETTINGS_API } from "../../vars";
import { showDangerToast, showSuccessToast } from "../../validation/ToastContainer";
import { securedFetch } from "../../auth/authService";


export async function getIdleTimeoutPeriod() {
    return securedFetch(`${SYSTEM_SETTINGS_API}/getidletimeout`, '', 'GET')
        .then(response => response.json())
        .then(data => {
            return data;
        })
}

export async function saveIdleTimeoutPeriod(idlePeriod) {

    const systemSettings = {
        name: 'idletimeout',
        value: idlePeriod,
        type: '',
        note: ''
    }

    return securedFetch(`${SYSTEM_SETTINGS_API}/saveidletimeout`, systemSettings, 'POST'
    ).then(async response => {
        if (!response.ok) {
            const json = await response.json();
            showDangerToast(`${json.message || 'Setting Idle-Timeout Period was not completed'}`, `Error ${response.status}`, 'Please Contact the Administrator!')
        } else {
            showSuccessToast('Setting Idle-Timeout Period is successful', 'Idle-Timeout Period')
        }
        return response.ok;
    })
}

export async function getComplianceTarget() {
    return securedFetch(`${SYSTEM_SETTINGS_API}/getcompliancetarget`, '', 'GET')
        .then(response => response.json())
        .then(data => {
            return data;
        })
}

export async function saveComplianceTarget(complianceTarget) {

    const systemSettings = {
        name: 'compliancetarget',
        value: complianceTarget,
        type: '',
        note: ''
    }

    return securedFetch(`${SYSTEM_SETTINGS_API}/savecompliancetarget`, systemSettings, 'POST'
    ).then(async response => {
        if (!response.ok) {
            const json = await response.json();
            showDangerToast(`${json.message || 'Setting Compliance Target was not completed'}`, `Error ${response.status}`, 'Please Contact the Administrator!')
        } else {
            showSuccessToast('Setting Compliance Target is successful', 'Compliance Target')
        }
        return response.ok;
    })
}

//Added by Octopus DevTeam Feb 8 2023
export async function saveValidationResultRetentionPeriod(days) {

    const systemSettings = {
        name: 'validationresult',
        value: days,
        type: '',
        note: ''
    }
    return securedFetch(`${SYSTEM_SETTINGS_API}/savevalidationresultretention`, systemSettings, 'POST'
    ).then(async response => {
        if (!response.ok) {
            const json = await response.json();
            showDangerToast(`${json.message || 'Setting Validation Results retention period was not completed'}`, `Error ${response.status}`, 'Please Contact the Administrator!')
        } else {
            showSuccessToast('Setting Validation & Violation Results retention period is successful', 'Validation & Violation Results')
        }
        return response.ok;
    })
}

//Added by Octopus DevTeam Feb 8 2023
export async function getValidationResultRetentionPeriod() {
    return securedFetch(`${SYSTEM_SETTINGS_API}/getvalidationresultretention`, '', 'GET')
        .then(response => response.json())
        .then(data => {
            return data;
        })
}

//Added by Octopus DevTeam Feb 23 2023
export async function saveBackupFilesRetentionPeriod(days) {
    const systemSettings = {
        name: 'backupfiles',
        value: days,
        type: '',
        note: ''
    }
    return securedFetch(`${SYSTEM_SETTINGS_API}/setbackupfiles`, systemSettings, 'POST'
    ).then(async response => {
        if (!response.ok) {
            const json = await response.json();
            showDangerToast(`${json.message || 'Setting Backup Files retention period was not completed'}`, `Error ${response.status}`, 'Please Contact the Administrator!')
        } else {
            showSuccessToast('Setting Backup Files retention period is successful', 'Backup Files')
        }
        return response.ok;
    })
}

//Added by Octopus DevTeam Feb 23 2023
export async function getBackupFilesRetentionPeriod() {
    return securedFetch(`${SYSTEM_SETTINGS_API}/getbackupfiles`, '', 'GET')
        .then(response => response.json())
        .then(data => {
            return data;
        })
}

//DevTeam: Mar 22, 2023
export async function getDeviceTypeFetchConfigCommand(deviceTypeId) {
    return securedFetch(`${SYSTEM_SETTINGS_API}/getFetchCommand/${deviceTypeId}`, '', 'GET')
        .then(response => response.json())
        .then(data => {
            return data;
        })
}

//DevTeam: Mar 22, 2023
export async function saveDeviceTypeFetchConfigCommand(fetchcommand) {
    const systemSettings = {
        name: 'fetchCommand',
        value: fetchcommand.fetchCommand,
        type: fetchcommand.deviceTypeId,
        note: ''
    }
    // alert ('name: '+systemSettings.name+' -value: '+systemSettings.value+' -type: '+systemSettings.type+' -note: '+systemSettings.note)
    return securedFetch(`${SYSTEM_SETTINGS_API}/saveFetchCommand`, systemSettings, 'POST'
    ).then(async response => {
        if (!response.ok) {
            const json = await response.json();
            showDangerToast(`${json.message || 'Setting DeviceType Fetch Command was not completed'}`, `Error ${response.status}`, 'Please Contact the Administrator!')
        } else {
            showSuccessToast('Setting DeviceType Fetch Command is successful', 'DeviceType Fetch Command')
        }
        return response.ok;
    })
}  


//#region ML Configs
export async function getMLToleranceValue() {
    return securedFetch(`${SYSTEM_SETTINGS_API}/getmltolerance`, '', 'GET')
        .then(response => response.json())
        .then(data => {
            return data;
        })
}
export async function saveMLToleranceValue(value) {
    const systemSettings = {
        name: 'mltolerance',
        value: value,
        type: '',
        note: ''
    }
    return securedFetch(`${SYSTEM_SETTINGS_API}/savemltolerance`, systemSettings, 'POST'
    ).then(async response => {
        if (!response.ok) {
            const json = await response.json();
            showDangerToast(`${json.message || 'Setting ML Tolerance was not completed'}`, `Error ${response.status}`, 'Please Contact the Administrator!')
        } else {
            showSuccessToast('Setting ML Tolerance is successful', 'ML Tolerance')
        }
        return response.ok;
    })
}

export async function getMLLearningPeriod() {
    return securedFetch(`${SYSTEM_SETTINGS_API}/getmllearningperiod`, '', 'GET')
    .then(response => response.json())
    .then(data => {
        return data;
    })
}
export async function saveMLLearningPeriod(value) {
    const systemSettings = {
        name: 'mllearningperiod',
        value: value,
        type: '',
        note: ''
    }
    // alert ('name: '+systemSettings.name+' -value: '+systemSettings.value+' -type: '+systemSettings.type+' -note: '+systemSettings.note)
    return securedFetch(`${SYSTEM_SETTINGS_API}/savemllearningperiod`, systemSettings, 'POST'
    ).then(async response => {
        if (!response.ok) {
            const json = await response.json();
            showDangerToast(`${json.message || 'Setting ML Learning Period was not completed'}`, `Error ${response.status}`, 'Please Contact the Administrator!')
        } else {
            showSuccessToast('Setting ML Learning Period is successful', 'ML Learning Period')
        }
        return response.ok;
    })
}
//#endregion


//#region Password Complexity
// export async function getPasswordComplexity() {
//     return securedFetch(`${SYSTEM_SETTINGS_API}/getidletimeout`, '', 'GET')
//         .then(response => response.json())
//         .then(data => {
//             return data;
//         })
// }

export async function getPasswordComplexity() {
    return securedFetch(`${SYSTEM_SETTINGS_API}/getPasswordComplexity`, '', 'GET')
        .then(async response => {
            if (!response.ok) {
                const json = await response.json();
                showDangerToast(
                    `${json.message || 'Fetching Password Complexity settings was not completed'}`,
                    `Error ${response.status}`,
                    'Please Contact the Administrator!'
                )
                return [];
            }
            return response.json();
        })
}

// export async function savePasswordComplexity(idlePeriod) {

//     const passwordComplexity = {
//         name: 'idletimeout',
//         value: idlePeriod,
//         type: '',
//         note: ''
//     }

//     return securedFetch(`${SYSTEM_SETTINGS_API}/saveidletimeout`, passwordComplexity, 'POST'
//     ).then(async response => {
//         if (!response.ok) {
//             const json = await response.json();
//             showDangerToast(`${json.message || 'Setting Idle-Timeout Period was not completed'}`, `Error ${response.status}`, 'Please Contact the Administrator!')
//         } else {
//             showSuccessToast('Setting Idle-Timeout Period is successful', 'Idle-Timeout Period')
//         }
//         return response.ok;
//     })
// }

export async function savePasswordComplexity(settingsArray) {

    return securedFetch(`${SYSTEM_SETTINGS_API}/savePasswordComplexity`, settingsArray, 'POST'
    ).then(async response => {
        if (!response.ok) {
            const json = await response.json();
            showDangerToast(
                `${json.message || 'Saving Password Complexity was not completed'}`,
                `Error ${response.status}`,
                'Please Contact the Administrator!'
            )
        } else {
            showSuccessToast('Password Complexity settings saved successfully', 'Password Complexity')
        }
        return response.ok;
    })
}
//#endregion